import React from "react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import Navbar from "../components/Navbar";
import { routes } from "../constants/routes";

const LandingHome = () => {
  return (
    <div className="landing-bg flex flex-col h-screen">
      <div className="space-y-16 container-xl flex-1 flex flex-col justify-center">
        <div className="">
          <p className="hidden md:block font-extrabold text-4xl md:text-7xl text-white">
            Welcome to the
          </p>
          <p className="font-extrabold text-5xl md:text-7xl text-blue-500">
            Youth Developer Conference.
          </p>
          <p className="mt-5 text-xl font-medium text-gray-200">
            Building the next generation of developers.
          </p>
        </div>

        <div className="md:flex items-center space-y-3 md:space-y-0 md:space-x-3">
          <a
            href={routes.about}
            className="w-full md:w-auto justify-center inline-flex items-center space-x-3 font-semibold ease-out transition-all duration-700 delay-150 transform hover:-translate-y-1 px-8 py-3 rounded-md shadow-lg hover:shadow-2xl bg-blue-500 hover:bg-blue-400 text-white"
          >
            <span>Learn more</span> <ArrowForwardIcon />
          </a>
          <a
            href={routes.scratchathon}
            className="w-full md:w-auto justify-center inline-flex items-center space-x-3 font-semibold ease-out transition-all duration-700 delay-150 transform hover:-translate-y-1 px-8 py-3 rounded-md shadow-lg hover:shadow-2xl bg-blue-700 hover:bg-blue-600 text-white"
          >
            <span>Check out the Scratchathon</span> <ArrowForwardIcon />
          </a>
        </div>
      </div>

      <div className=" py-5 bg-black bg-opacity-0 hover:bg-opacity-50 transition-all duration-1000">
        <Navbar lgContainer darkBg />
      </div>
    </div>
  );
};

export default LandingHome;
